import React from "react";
import "./MenuTop.css";

const MenuPageDivisionStrength = () => {
  return (
    <nav className="MenuTop d-flex navbar">
      <h3 className="my-2 ps-5">
        <i className="bi bi-triangle-fill me-2"></i> Division strength
      </h3>
    </nav>
  );
};

export default MenuPageDivisionStrength;
